import Vue from "vue";
import {mapGetters} from "vuex";
import {Toast} from 'vant';
import {ImagePreview} from 'vant';

Vue.mixin({
    data() {
        return {
            mixinShowUrl: false,// 展示 分享谈框
            isWx: false
        };
    },
    computed: {
        ...mapGetters({
            tokenGetter: "tokenGetter", //token信息
            userInfoGetter: "userInfoGetter", // 用户信息
            tabActiveGetter: "tabActiveGetter", // tab索引
            tabHeightGetter: "tabHeightGetter", // tab高度

        }),
    },
    mounted() {
        if (window.__wxjs_environment === 'miniprogram') {
            /* eslint-disable */
            wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                    this.isWx = true
                }
            })
        } else {
            this.isWx = false
        }

    },
    methods: {
        imageShowFn(item) {
            ImagePreview({
                images: [item],
                startPosition: 0,
                loop: true,
                closeable: true,
            });
        },
        routerPush(url) {
            if (!url) {
                Toast('敬请期待');
                return;
            }
            if (!this.tokenGetter) {
                this.$store.commit("setNavigateTo");
                return
            }
            this.$router.push(url)
        },

    },
});
